module.exports = __webpack_public_path__ + "img/equipos-moviles-gal-3-zoom.35ac48dc.jpg";